import { Link } from '@eventbrite/eds-link';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import { isEmbedUrl } from '../../utils';
import { Iframe } from './Iframe';

interface Props {
    url: string;
    imageUrl: string;
    action: any;
    shouldEmbed?: boolean;
}

export const EmbedWithFallbackContent: React.FC<Props> = ({
    url = '',
    imageUrl,
    action,
    shouldEmbed = false,
}) => {
    let component = (
        <Link
            to={url}
            target="_blank"
            title={gettext('Click to join the event')}
            onClick={action}
        >
            <div
                className={classNames('dc-main-image-wrapper', {
                    'dc-main-image-wrapper--empty': !imageUrl,
                })}
            >
                {imageUrl && <img className="dc-main-image" src={imageUrl} />}
            </div>
        </Link>
    );

    if (isEmbedUrl(url) || shouldEmbed) {
        component = <Iframe url={url} />;
    }

    return component;
};
